define('app/views/success_bank_card_view',['app/setup', 'app/views/base_view', 'app/views/success_bank_card_submit_btn_view'], function (takhfifan, baseView) {

  takhfifan.SuccessBankCardView = takhfifan.BaseView.extend({

    initialize: function () {
      var self = this;
      takhfifan.eventHub.on('success:couponGenerated', function () {
        self.showBankCard(0, self);
      }, this);
      this.orderId = this.$el.data('orderIncrementId');
      this.cashBackAmount = this.$el.data('cashbackAmount');
      this.customerId = this.$el.data('customerId');
      this.giftAmount = null;
      this.giftAPICalled = false;
      this.getBankCardGiftAmount();

      takhfifan.eventHub.on('successBankCardBtn:clicked', function () {
        self.addBankCard(self);
      }, this);

    },

    showBankCard: function (retry, self) {
      if (!self.giftAPICalled) {
        if (retry < 40) { // means timeout after 40 retry or in another word 40 sec
          setTimeout(function () {
            self.showBankCard(retry + 1, self)
          }, 1000);
          return;
        }
      }
      if (self.giftAmount && self.giftAmount > 0) {
        if (!self.template) {
          self.template = _.template($('#bankCardTemplate').html());
        }

        var codesOutput = self.template({
          gift_full: Math.floor(self.giftAmount / 10),
          gift_short: Math.floor(self.giftAmount / 10)
        });

        self.$el.append(codesOutput);
        self.addEvents();
      }
    },

    addEvents: function () {
      var self = this;
      $('.card_number_input').each(function () {
        var $this = $(this);
        $this.keyup(function (e) {
          self.cardNumberKeyUp(e)
        });
      });

      $('#offcb-add-cart-form__submit').each(function () {
        var $this = $(this);
        new takhfifan.SuccessBankCardSubmitBtnView({
          el: $this
        });
      });

      self.$errorEl = self.$el.find('.offcb-add-cart-form__error-message').first();
    },

    getBankCardGiftAmount: function () {
      var self = this;
      $.get('/v4/api/mautic/gifts')
        .done(function (data) {
          if (!data.gift_candidate) {
            self.giftAPICalled = true;
            return;
          }
          if (data.gift_amount) {
            self.giftAmount = data.gift_amount;
            self.giftAPICalled = true;
            return;
          }
          self.giftAmount = self.cashBackAmount;
          self.giftAPICalled = true;
        })
        .fail(function (data) {
            self.giftAPICalled = true;
            console.error('could not check user\'s BankCard Gift, Details:');
            if (data.responseJSON) {
              console.error(data.responseJSON);
            } else {
              console.error(data);
            }
          }
        );
    },

    cardNumberKeyUp: function (e) {
      var target = e.srcElement || e.target;
      var maxLength = parseInt(target.attributes["maxlength"].value, 10);
      var myLength = target.value.length;
      if (myLength >= maxLength) {
        var next = target;
        while (next = next.nextElementSibling) {
          if (next == null)
            break;
          if (next.tagName.toLowerCase() === "input") {
            next.focus();
            break;
          }
        }
      }
    },

    addError: function (message) {
      if (this.$errorEl.length === 0) {
        takhfifan.eventHub.trigger('message:show', {
          type: 'error',
          msg: message
        });
        return
      }
      this.$errorEl.empty().append('<span>' + message + '</span>');
      this.$errorEl.show();
    },

    removeError: function () {
      if (this.$errorEl.length !== 0) {
        this.$errorEl.hide();
      }

    },

    showSuccess: function () {
      var successContent = $(this.$el.find('.bank-card-success-box').first());
      var titleContent = $(this.$el.find('.bank-card-form-box').first());
      var formContent = $(this.$el.find('.bank-card-title-box').first());

      if (successContent.length === 0) {
        takhfifan.eventHub.trigger('message:show', {
          type: 'success',
          msg: i18n.t('bank_card_added_successfully')
        });
        return
      }
      formContent.hide();
      titleContent.hide();
      successContent.show();
    },

    getCardNumber: function (self) {
      var cardNumber = '';
      cardNumber += self.$el.find("#cart-segment-0").first().val();
      cardNumber += self.$el.find("#cart-segment-1").first().val();
      cardNumber += self.$el.find("#cart-segment-2").first().val();
      cardNumber += self.$el.find("#cart-segment-3").first().val();

      return cardNumber;
    },

    validateCardNumber: function (cardNumber) {
      if (cardNumber.length != 16) {
        return false;
      }

      if (!(/^\d+$/.test(cardNumber))) {
        return false;
      }

      return true;
    },

    addBankCard: function (self) {

      var cardNumber = self.getCardNumber(self);
      if (!self.validateCardNumber(cardNumber)) {
        takhfifan.eventHub.trigger('successBankCard:addCardApiCalled', {});
        self.addError(i18n.t('invalid_bank_card'));
        return;
      }
      self.removeError();
      var params = {
        "data": {
          "card_no": cardNumber,
          "added_on": "CORE_SUCCESS_PURCHASE_PAGE"
        },
        "userId": self.customerId,
      };
      $.post('/v4/api/offline_cashback/user/' + self.customerId + '/card/queue', params)
        .done(function (data) {
          takhfifan.eventHub.trigger('successBankCard:addCardApiCalled', {});
          if (data && data.status_code === "200" && data.data.card_status) {
            self.notifyOrderCompleted(self);
          } else {
            console.error('could not Add Bank Card Details:');
            console.error(data);
            self.addError(i18n.t('an_error_occurred'));
          }
          if (_.isFunction(window.ga)) {
            takhfifan.eventHub.trigger('success_bank_card:submit', {});
          }
        })
        .fail(function (data) {
            takhfifan.eventHub.trigger('successBankCard:addCardApiCalled', {});
            console.error('could not Add Bank Card Details:');
            if (data.responseJSON) {
              console.error(data.responseJSON);
            } else {
              console.error(data);
            }
            if (data.responseJSON && data.responseJSON.errors && data.responseJSON.errors["data.card_no"]
              && data.responseJSON.errors["data.card_no"].length > 0
            ) {
              self.addError(data.responseJSON.errors["data.card_no"][0]);
            } else {
              self.addError(i18n.t('an_error_occurred'));
            }
            if (_.isFunction(window.ga)) {
              takhfifan.eventHub.trigger('success_bank_card:submit', {});
            }
          }
        );
    },

    notifyOrderCompleted: function (self) {
      $.get('/ajax/onepage/notifyRendererMautic/orderId/' + self.orderId)
        .done(function (data) {
          if (data.success) {
            self.showSuccess()
          }
          console.error('could not notify renderer about gift, Details: Invalid Success format in response');
          self.addError(i18n.t('success_bank_card_added_gift_failed'));
        })
        .fail(function (data) {
            self.mauticNotified = false;
            console.error('could not notify renderer about gift, Details:');
            if (data.responseJSON && data.responseJSON.message) {
              console.error(data.responseJSON.message);
            } else {
              console.error('No Details provided');
            }
            self.addError(i18n.t('success_bank_card_added_gift_failed'));
          }
        );
    }

  })
});
